import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { formatNumber } from 'utils/currencyFormat';
import TextInputOnRow from 'components/GenericComponent/TextInputOnRow';
import { pushNotification } from 'utils/notifications';
import { Checkbox } from 'antd';

const ThuocTinhGiamTru = (props) => {
    let { show, onHide, data
        , giagoivay, setGiaGoiVay
        , giasanpham, setGiaSanPham
        , listThuocTinhGiamTruSelect, setListThuocTinhGiamTruSelect
        , setTongTienGiamTruSelect } = props;

    const [ListChecked, setChecked] = useState([]);
    const [TienGiamTru, setTienGiamTru] = useState(0);

    useEffect(() => {
        if (listThuocTinhGiamTruSelect && listThuocTinhGiamTruSelect.length > 0) {
            var updatedList = [];
            var tiengiamtru = 0;
            listThuocTinhGiamTruSelect.map((item, idx) => {
                updatedList.push(item.ThuocTinhGiamTruId);
                tiengiamtru += parseFloat(item.TienGiamTru);
            })
            setChecked(updatedList);
            setTienGiamTru(tiengiamtru);
        }
    }, []);

    // Add/Remove checked item from list
    const handleCheck = (event) => {

        var updatedList = [...ListChecked];

        if (event.target.checked) {
            updatedList = [...ListChecked, event.target.value];
        } else {
            updatedList.splice(ListChecked.indexOf(event.target.value), 1);
        }
        console.log(updatedList);

        // updatedList.map((iSelect, i) => {
        //     var index = data.indexOf(iSelect)
        //     console.log(index);
        // })
        var tongtiengiamtru = 0;
        var thuoctinhSelect = [];
        data && data.map((item, idx) => {
            updatedList.map((iSelect, index) => {
                if (parseInt(iSelect) === parseInt(item.ThuocTinhGiamTruId)) {
                    //alert(item.ThuocTinhGiamTruId)
                    tongtiengiamtru += parseFloat(item.TienGiamTru);
                    thuoctinhSelect.push(item);
                }
            })
        })
        giagoivay = parseFloat(giagoivay) + parseFloat(TienGiamTru) - parseFloat(tongtiengiamtru);
        giasanpham = parseFloat(giasanpham) + parseFloat(TienGiamTru) - parseFloat(tongtiengiamtru);
        setGiaGoiVay(giagoivay);
        setGiaSanPham(giasanpham);

        setChecked(updatedList);
        setTienGiamTru(tongtiengiamtru);
        setListThuocTinhGiamTruSelect(thuoctinhSelect);
        setTongTienGiamTruSelect(tongtiengiamtru);
    };



    // // Generate string of checked items
    // const checkedItems = checked.length
    //     ? checked.reduce((total, item) => {
    //         return total + ", " + item;
    //     })
    //     : "";

    // // Return classes based on whether item is checked
    // var isChecked = (item) =>
    //     checked.includes(item) ? "checked-item" : "not-checked-item";


    //let { StoreName, StoreAddress, StoreStatus, StoreId, errors } = this.state;
    return (
        <Modal
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left popup-detail"
        //style={{ top: "100px" }}
        >
            <Modal.Header style={{ backgroundColor: "#d8e9eb", color: "#000", display: "flex", alignItems: "center" }}>
                <div className="col-md-10 modal-title" style={{ fontSize: "14px", width: "100%", display: "flex", alignItems: "center", textAlign: "center" }}>
                    {/* <span className="btn-icon-right">
                            <i className="fas fa-plus"></i>
                        </span>{' '}
                        Thuộc tính giảm trừ */}
                    <div className="row" style={{ width: "100%", display: "flex", alignItems: "center" }}>
                        <div className="col-md-6">Giá sau giảm trừ
                            <br /><b style={{ color: "#c24133" }}>{formatNumber(giasanpham)}</b></div>
                        <div className="col-md-6">Giá cho vay tối đa
                            <br /><b style={{ color: "#c24133" }}>{formatNumber(giagoivay)}</b></div>
                    </div>
                </div>
                <button
                    type="button"
                    className="close-popup-new"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={onHide}
                >
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body >
                <form className="form tat-toan form-horizontal form-edit">
                    <div className="form-body"  >
                        {data &&
                            data.map((item, idx) => (
                                <>
                                    <div className='col-md-12' style={{
                                        border: "1px", borderRadius: "4px", borderStyle: "solid", borderColor: "#CACFE7"
                                        , display: "flex", alignItems: "center", height: "35px", marginBottom: "5px", paddingRight: "0px"
                                    }}>
                                        <div className='row' style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                            <div className='col-md-8' style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                                {ListChecked.indexOf(item.ThuocTinhGiamTruId) >= 0 && (
                                                    <input type="checkbox" value={item.ThuocTinhGiamTruId} id={'ThuocTinhGiamTru' + idx} onChange={handleCheck} checked="check"></input>
                                                )}
                                                {ListChecked.indexOf(item.ThuocTinhGiamTruId) < 0 && (
                                                    <input type="checkbox" value={item.ThuocTinhGiamTruId} id={'ThuocTinhGiamTru' + idx} onChange={handleCheck}></input>
                                                )}
                                                <label for={'ThuocTinhGiamTru' + idx} style={{ marginLeft: "10px", marginBottom: "0px" }}>{item.TenThuocTinh}</label>
                                            </div>
                                            <div className='col-md-4' style={{ textAlign: "right", color: "#c24133", paddingRight: "0px" }}>
                                                -{formatNumber(item.TienGiamTru)}
                                            </div>
                                        </div>

                                    </div>
                                </>
                            ))}
                    </div>

                </form>
            </Modal.Body>
        </Modal >
    );
}
export default ThuocTinhGiamTru;
